export class FormComponentsConfig {
  static readonly MIN_LENGTH_OF_SEARCH = 3;
}
